module.exports = __webpack_public_path__ + "static/media/4-4.ac038eb7.mp3";